import { Component, Input, OnInit, ViewChildren } from '@angular/core';
import { Chart, registerables } from 'chart.js';
import annotationPlugin from 'chartjs-plugin-annotation';
import pdfMake from 'pdfmake/build/pdfmake';
import domtoimage from 'dom-to-image';
import { MeasureService } from 'src/app/modules/measure/measure.service';
import { map } from 'rxjs/operators';
import { DateTimePipe } from '../../pipe/date.pipe';

@Component({
  selector: 'lifedi-report-boxchart',
  templateUrl: './report-boxchart.component.html',
  styleUrls: ['./report-boxchart.component.scss'],
})
export class ReportBoxchartComponent implements OnInit {
  @Input() measureid: string;
  @Input() type: string;
  @Input() view_status: number;
  @Input() access_id: string;
  @Input() informant_type: string;
  @ViewChildren('allcanvas') myCharts: any;

  isLoading: boolean = false;
  data_report;
  chartArr = [];

  constructor(private measureService: MeasureService) { }

  ngOnInit(): void {
    Chart.register(...registerables);
    Chart.register(annotationPlugin);
    let body;
    if (this.access_id) {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        ACCESS_ID: this.access_id,
        INFORMANT_TYPE: this.informant_type,
      };
    } else {
      body = {
        MEASURE_ID: this.measureid,
        TYPE_REPORT: this.type,
        INFORMANT_TYPE: this.informant_type,
      };
    }

    // console.log(body);
    this.measureService
      .getReportByMeasureId(body)
      .pipe(
        map((res) => {
          this.data_report = [res.result];
          // console.log(res.result);

          setTimeout(() => {
            for (let i = 0; i < this.data_report[0].data.length; i++) {
              var myChart1 = new Chart('ScatterChart' + i, {
                type: 'scatter',
                data: {
                  datasets: [
                    {
                      label: 'Answer',
                      data: [
                        {
                          x: this.data_report[0].data[i].xaxis_value,
                          y: this.data_report[0].data[i].yaxis_value,
                        },
                      ],
                      borderColor: 'transparent',
                      backgroundColor: 'transparent',
                    },
                  ],
                },
                options: {
                  scales: {
                    x: {
                      display: false,
                      beginAtZero: false,
                      type: 'linear',
                      position: 'bottom',
                      max: this.data_report[0].data[i].xmax, //กล่องขวาล่างมุมขวาล่าง
                    },
                    y: {
                      display: false,
                      beginAtZero: false,
                      max: this.data_report[0].data[i].ymax, //กล่องซ้ายบนจุดซ้ายบน
                    },
                  },

                  plugins: {
                    legend: {
                      display: false,
                    },
                    annotation: {
                      annotations: {
                        box1: {
                          type: 'box', // left-bottom
                          xMin: this.data_report[0].data[i].box_data[2]
                            .bl_point_x, //0
                          xMax: this.data_report[0].data[i].box_data[2]
                            .br_point_x, //4
                          yMin: this.data_report[0].data[i].box_data[2]
                            .bl_point_y, //0
                          yMax: this.data_report[0].data[i].box_data[2]
                            .tl_point_y, //5
                          backgroundColor:
                            this.data_report[0].data[i].box_data[2].box_color,
                          borderColor: 'white',
                          borderWidth: 1,
                        },
                        line1: {
                          type: 'line', // left-bottom
                          borderColor: 'transparent',
                          xMin:
                            (+this.data_report[0].data[i].box_data[2]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[2]
                                .bl_point_x) /
                            2, //3
                          xMax:
                            (+this.data_report[0].data[i].box_data[2]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[2]
                                .bl_point_x) /
                            2, //3
                          yMin:
                            (+this.data_report[0].data[i].box_data[2]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[2]
                                .bl_point_y) /
                            2, //7.5
                          yMax:
                            (+this.data_report[0].data[i].box_data[2]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[2]
                                .bl_point_y) /
                            2, //7.5
                          label: {
                            font: {
                              size: 14,
                              family: 'Sarabun',
                            },
                            enabled: true,
                            color:
                              this.data_report[0].data[i].box_data[2]
                                .text_color, //font color
                            content:
                              this.data_report[0].data[i].box_data[2].type_name,
                            backgroundColor: 'transparent',
                          },
                        },
                        box2: {
                          type: 'box', // left-top
                          xMin: this.data_report[0].data[i].box_data[0]
                            .bl_point_x, //0
                          xMax: this.data_report[0].data[i].box_data[0]
                            .br_point_x, //6
                          yMin: this.data_report[0].data[i].box_data[0]
                            .bl_point_y, //5
                          yMax: this.data_report[0].data[i].box_data[0]
                            .tl_point_y, //10
                          backgroundColor:
                            this.data_report[0].data[i].box_data[0].box_color,
                          borderColor: 'white',
                          borderWidth: 1,
                        },
                        line2: {
                          type: 'line', // left-top
                          borderColor: 'transparent',
                          xMin:
                            (+this.data_report[0].data[i].box_data[0]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[0]
                                .bl_point_x) /
                            2, //3
                          xMax:
                            (+this.data_report[0].data[i].box_data[0]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[0]
                                .bl_point_x) /
                            2, //3
                          yMin:
                            (+this.data_report[0].data[i].box_data[0]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[0]
                                .bl_point_y) /
                            2, //7.5
                          yMax:
                            (+this.data_report[0].data[i].box_data[0]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[0]
                                .bl_point_y) /
                            2, //7.5
                          label: {
                            font: {
                              size: 14,
                              family: 'Sarabun',
                            },
                            enabled: true,
                            color:
                              this.data_report[0].data[i].box_data[0]
                                .text_color,
                            content:
                              this.data_report[0].data[i].box_data[0].type_name,
                            backgroundColor: 'transparent',
                          },
                        },
                        box3: {
                          type: 'box', // right bottom
                          xMin: this.data_report[0].data[i].box_data[3]
                            .bl_point_x, //
                          xMax: this.data_report[0].data[i].box_data[3]
                            .br_point_x, //
                          yMin: this.data_report[0].data[i].box_data[3]
                            .bl_point_y, //
                          yMax: this.data_report[0].data[i].box_data[3]
                            .tl_point_y, //
                          backgroundColor:
                            this.data_report[0].data[i].box_data[3].box_color,
                          borderColor: 'white',
                          borderWidth: 1,
                        },
                        line3: {
                          type: 'line', // right bottom
                          borderColor: 'transparent',
                          xMin:
                            (+this.data_report[0].data[i].box_data[3]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[3]
                                .bl_point_x) /
                            2, //
                          xMax:
                            (+this.data_report[0].data[i].box_data[3]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[3]
                                .bl_point_x) /
                            2, //
                          yMin:
                            (+this.data_report[0].data[i].box_data[3]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[3]
                                .bl_point_y) /
                            2, //
                          yMax:
                            (+this.data_report[0].data[i].box_data[3]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[3]
                                .bl_point_y) /
                            2, //
                          label: {
                            font: {
                              size: 14,
                              family: 'Sarabun',
                            },
                            enabled: true,
                            color:
                              this.data_report[0].data[i].box_data[3]
                                .text_color,
                            content:
                              this.data_report[0].data[i].box_data[3].type_name,
                            backgroundColor: 'transparent',
                          },
                        },
                        box4: {
                          type: 'box', // right top
                          xMin: this.data_report[0].data[i].box_data[1]
                            .bl_point_x, //
                          xMax: this.data_report[0].data[i].box_data[1]
                            .br_point_x, //
                          yMin: this.data_report[0].data[i].box_data[1]
                            .bl_point_y, //
                          yMax: this.data_report[0].data[i].box_data[1]
                            .tl_point_y, //
                          backgroundColor:
                            this.data_report[0].data[i].box_data[1].box_color,
                          borderColor: 'white',
                          borderWidth: 1,
                        },
                        line4: {
                          type: 'line', // right top
                          borderColor: 'transparent',
                          xMin:
                            (+this.data_report[0].data[i].box_data[1]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[1]
                                .bl_point_x) /
                            2, //
                          xMax:
                            (+this.data_report[0].data[i].box_data[1]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[1]
                                .bl_point_x) /
                            2, //
                          yMin:
                            (+this.data_report[0].data[i].box_data[1]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[1]
                                .bl_point_y) /
                            2, //
                          yMax:
                            (+this.data_report[0].data[i].box_data[1]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[1]
                                .bl_point_y) /
                            2, //
                          label: {
                            font: {
                              size: 14,
                              family: 'Sarabun',
                            },
                            enabled: true,
                            color:
                              this.data_report[0].data[i].box_data[1]
                                .text_color,
                            content:
                              this.data_report[0].data[i].box_data[1].type_name,
                            backgroundColor: 'transparent',
                          },
                        },
                      },
                    },
                  },
                },
              });
            }
            for (let i = 0; i < this.data_report[0].data.length; i++) {
              var myChart2 = new Chart('ScatterChartpdf' + i, {
                type: 'scatter',
                data: {
                  datasets: [
                    {
                      label: 'Answer',
                      data: [
                        {
                          x: this.data_report[0].data[i].xaxis_value,
                          y: this.data_report[0].data[i].yaxis_value,
                        },
                      ],
                      borderColor: 'transparent',
                      backgroundColor: 'transparent',
                    },
                  ],
                },
                options: {
                  animation: false,
                  scales: {
                    x: {
                      display: false,
                      beginAtZero: true,
                      type: 'linear',
                      position: 'bottom',
                      max: this.data_report[0].data[i].xmax, //กล่องขวาล่างมุมขวาล่าง
                    },
                    y: {
                      display: false,
                      beginAtZero: true,
                      max: this.data_report[0].data[i].ymax, //กล่องซ้ายบนจุดซ้ายบน
                    },
                  },

                  plugins: {
                    legend: {
                      display: false,
                    },
                    annotation: {
                      annotations: {
                        box1: {
                          type: 'box', // left-bottom
                          xMin: this.data_report[0].data[i].box_data[2]
                            .bl_point_x, //0
                          xMax: this.data_report[0].data[i].box_data[2]
                            .br_point_x, //4
                          yMin: this.data_report[0].data[i].box_data[2]
                            .bl_point_y, //0
                          yMax: this.data_report[0].data[i].box_data[2]
                            .tl_point_y, //5
                          backgroundColor:
                            this.data_report[0].data[i].box_data[2].box_color,
                          borderColor: 'white',
                          borderWidth: 1,
                        },
                        line1: {
                          type: 'line', // left-bottom
                          borderColor: 'transparent',
                          xMin:
                            (+this.data_report[0].data[i].box_data[2]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[2]
                                .bl_point_x) /
                            2, //3
                          xMax:
                            (+this.data_report[0].data[i].box_data[2]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[2]
                                .bl_point_x) /
                            2, //3
                          yMin:
                            (+this.data_report[0].data[i].box_data[2]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[2]
                                .bl_point_y) /
                            2, //7.5
                          yMax:
                            (+this.data_report[0].data[i].box_data[2]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[2]
                                .bl_point_y) /
                            2, //7.5
                          label: {
                            font: {
                              size: 22,
                              family: 'Sarabun',
                            },
                            enabled: true,
                            color:
                              this.data_report[0].data[i].box_data[2]
                                .text_color, //font color
                            content:
                              this.data_report[0].data[i].box_data[2].type_name,
                            backgroundColor: 'transparent',
                          },
                        },
                        box2: {
                          type: 'box', // left-top
                          xMin: this.data_report[0].data[i].box_data[0]
                            .bl_point_x, //0
                          xMax: this.data_report[0].data[i].box_data[0]
                            .br_point_x, //6
                          yMin: this.data_report[0].data[i].box_data[0]
                            .bl_point_y, //5
                          yMax: this.data_report[0].data[i].box_data[0]
                            .tl_point_y, //10
                          backgroundColor:
                            this.data_report[0].data[i].box_data[0].box_color,
                          borderColor: 'white',
                          borderWidth: 1,
                        },
                        line2: {
                          type: 'line', // left-top
                          borderColor: 'transparent',
                          xMin:
                            (+this.data_report[0].data[i].box_data[0]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[0]
                                .bl_point_x) /
                            2, //3
                          xMax:
                            (+this.data_report[0].data[i].box_data[0]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[0]
                                .bl_point_x) /
                            2, //3
                          yMin:
                            (+this.data_report[0].data[i].box_data[0]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[0]
                                .bl_point_y) /
                            2, //7.5
                          yMax:
                            (+this.data_report[0].data[i].box_data[0]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[0]
                                .bl_point_y) /
                            2, //7.5
                          label: {
                            font: {
                              size: 22,
                              family: 'Sarabun',
                            },
                            enabled: true,
                            color:
                              this.data_report[0].data[i].box_data[0]
                                .text_color,
                            content:
                              this.data_report[0].data[i].box_data[0].type_name,
                            backgroundColor: 'transparent',
                          },
                        },
                        box3: {
                          type: 'box', // right bottom
                          xMin: this.data_report[0].data[i].box_data[3]
                            .bl_point_x, //
                          xMax: this.data_report[0].data[i].box_data[3]
                            .br_point_x, //
                          yMin: this.data_report[0].data[i].box_data[3]
                            .bl_point_y, //
                          yMax: this.data_report[0].data[i].box_data[3]
                            .tl_point_y, //
                          backgroundColor:
                            this.data_report[0].data[i].box_data[3].box_color,
                          borderColor: 'white',
                          borderWidth: 1,
                        },
                        line3: {
                          type: 'line', // right bottom
                          borderColor: 'transparent',
                          xMin:
                            (+this.data_report[0].data[i].box_data[3]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[3]
                                .bl_point_x) /
                            2, //
                          xMax:
                            (+this.data_report[0].data[i].box_data[3]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[3]
                                .bl_point_x) /
                            2, //
                          yMin:
                            (+this.data_report[0].data[i].box_data[3]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[3]
                                .bl_point_y) /
                            2, //
                          yMax:
                            (+this.data_report[0].data[i].box_data[3]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[3]
                                .bl_point_y) /
                            2, //
                          label: {
                            enabled: true,
                            font: {
                              size: 22,
                              family: 'Sarabun',
                            },
                            color:
                              this.data_report[0].data[i].box_data[3]
                                .text_color,
                            content:
                              this.data_report[0].data[i].box_data[3].type_name,
                            backgroundColor: 'transparent',
                          },
                        },
                        box4: {
                          type: 'box', // right top
                          xMin: this.data_report[0].data[i].box_data[1]
                            .bl_point_x, //
                          xMax: this.data_report[0].data[i].box_data[1]
                            .br_point_x, //
                          yMin: this.data_report[0].data[i].box_data[1]
                            .bl_point_y, //
                          yMax: this.data_report[0].data[i].box_data[1]
                            .tl_point_y, //
                          backgroundColor:
                            this.data_report[0].data[i].box_data[1].box_color,
                          borderColor: 'white',
                          borderWidth: 1,
                        },
                        line4: {
                          type: 'line', // right top
                          borderColor: 'transparent',
                          xMin:
                            (+this.data_report[0].data[i].box_data[1]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[1]
                                .bl_point_x) /
                            2, //
                          xMax:
                            (+this.data_report[0].data[i].box_data[1]
                              .br_point_x +
                              +this.data_report[0].data[i].box_data[1]
                                .bl_point_x) /
                            2, //
                          yMin:
                            (+this.data_report[0].data[i].box_data[1]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[1]
                                .bl_point_y) /
                            2, //
                          yMax:
                            (+this.data_report[0].data[i].box_data[1]
                              .tl_point_y +
                              +this.data_report[0].data[i].box_data[1]
                                .bl_point_y) /
                            2, //
                          label: {
                            font: {
                              size: 22,
                              family: 'Sarabun',
                            },
                            enabled: true,
                            color:
                              this.data_report[0].data[i].box_data[1]
                                .text_color,
                            content:
                              this.data_report[0].data[i].box_data[1].type_name,
                            backgroundColor: 'transparent',
                          },
                        },
                      },
                    },
                  },
                },
              });
              this.chartArr.push(myChart2);
              if (i === this.data_report[0].data.length - 1) {
                this.filepdf();
              }
            }
            this.isLoading = true;
          }, 1000);
          // setTimeout(() => {
          //   this.filepdf();
          // }, 1000);
        })
      )
      .subscribe(() => { });
    this.isLoading = false;
  }

  downloadpdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;
    let username = this.data_report[0].username;
    let alldata = this.data_report;
    let NewArray = [];
    for (let i = 0; i < alldata[0].data.length; i++) {
      let a = document.getElementById('ScatterChartpdf' + i);
      NewArray.push(a);
    }


    Promise.all(NewArray.map((node) => domtoimage.toPng(node))).then(
      (dataArray) => {
        dataArray[0];
        var img = new Image();
        img.src = dataArray[0];
        pdfMake.fonts = {
          THsarabunNew: {
            normal: 'THSarabun.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNew BoldItalic.ttf',
          },
        };
        const allPage = {
          pageSize: 'A4',
          pageOrientation: 'portrait',
          header: function (currentPage) {
            return [
              {
                text:
                  username +
                  ' ( userid : ' +
                  userid +
                  ' )' +
                  '  | ' +
                  formattedDate +
                  ' หน้า ' +
                  currentPage.toString(),
                width: '*',
                alignment: 'right',
                margin: [40, 20],
              },
            ];
          },
          content: [
            {
              text: this.data_report[0].reportname,
              alignment: 'center',
              fontSize: 24,
              color: '#060e9f',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].measure_name,
              alignment: 'left',
              fontSize: 22,
              decoration: 'underline',
              margin: [0, 10],
              bold: true,
            },
            {
              text: this.data_report[0].report_description,
              width: '*',
              fontSize: 16,
              margin: [0, 0, 0, 15],
            },
            {
              image: dataArray[0],
              width: 300,
              alignment: 'center',
              margin: [0, 20],
            },
            {
              text: this.data_report[0].data[0].xaxis_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data[0].xaxis_color,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report[0].data[0].xaxis_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report[0].data[0].xmin +
                ' คะแนนสูงสุด : ' +
                this.data_report[0].data[0].xmax,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report[0].data[0].xaxis_value).toFixed(2) +
                ' คะแนน',
              // ' อยู่ในช่วงคะแนน ' +
              // this.data_report[0].data[0].xaxis_range +
              // ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: this.data_report[0].data[0].xaxis_color,
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report[0].data[0].xaxis_range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text: '_____________________________________________________________________________________________',
              alignment: 'center',
              fontSize: 10,
              color: 'gray',
              margin: [0, 10],
            },
            {
              text: this.data_report[0].data[0].yaxis_name,
              alignment: 'left',
              decoration: 'underline',
              color: this.data_report[0].data[0].yaxis_color,
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },

            {
              text: this.data_report[0].data[0].yaxis_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report[0].data[0].ymin +
                ' คะแนนสูงสุด : ' +
                this.data_report[0].data[0].ymax,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report[0].data[0].yaxis_value).toFixed(2) +
                ' คะแนน',
              // ' อยู่ในช่วงคะแนน ' +
              // this.data_report[0].data[0].yaxis_range +
              // ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: this.data_report[0].data[0].yaxis_color,
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report[0].data[0].yaxis_range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text: '_____________________________________________________________________________________________',
              alignment: 'center',
              fontSize: 10,
              color: 'gray',
              margin: [0, 10],
            },
            {
              text: 'สรุปผล',
              alignment: 'center',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 10, 0, 5],
              width: 'auto',
              fontSize: 22,
              bold: true,
            },
            {
              text: this.data_report[0].data[0].result_type,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },

            {
              text: this.data_report[0].data[0].result_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text: '_____________________________________________________________________________________________',
              alignment: 'center',
              fontSize: 10,
              color: 'gray',
              margin: [0, 10],
            },
          ],
          defaultStyle: {
            font: 'THsarabunNew',
          },
        };
        for (let i = 1; i < this.data_report[0].data.length; i++) {
          dataArray[i];
          let img2 = new Image();
          img2.src = dataArray[i];

          allPage.content.push(
            {
              image: dataArray[i],
              width: 300,
              alignment: 'center',
              margin: [0, 40, 0, 20],
            },
            {
              text: this.data_report[0].data[i].xaxis_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },
            {
              text: this.data_report[0].data[i].xaxis_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report[0].data[i].xmin +
                ' คะแนนสูงสุด : ' +
                this.data_report[0].data[i].xmax,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report[0].data[i].yaxis_value).toFixed(2) +
                ' คะแนน',
              // ' อยู่ในช่วงคะแนน ' +
              // this.data_report[0].data[i].yaxis_range +
              // ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report[0].data[i].xaxis_range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text: '_____________________________________________________________________________________________',
              alignment: 'center',
              fontSize: 10,
              color: 'gray',
              margin: [0, 10],
            },
            {
              text: this.data_report[0].data[i].yaxis_name,
              alignment: 'left',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },

            {
              text: this.data_report[0].data[i].yaxis_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text:
                'คะแนนต่ำสุด : ' +
                this.data_report[0].data[i].ymin +
                ' คะแนนสูงสุด : ' +
                this.data_report[0].data[i].ymax,
              alignment: 'left',
              fontSize: 18,
              color: '#000000',
              margin: [0, 10, 0, 0],
              bold: true,
            },
            {
              text:
                'ท่านได้ ' +
                parseFloat(this.data_report[0].data[i].xaxis_value).toFixed(2) +
                ' คะแนน',
              // ' อยู่ในช่วงคะแนน ' +
              // this.data_report[0].data[i].xaxis_range +
              // ' คะแนน',
              alignment: 'left',
              fontSize: 18,
              color: '#060e9f',
              margin: [0, 5, 0, 0],
              bold: true,
            },
            {
              text: this.data_report[0].data[i].yaxis_range_description,
              width: '*',
              fontSize: 14,
              margin: [0, 0, 0, 10],
            },
            {
              text: '_____________________________________________________________________________________________',
              alignment: 'center',
              fontSize: 10,
              color: 'gray',
              margin: [0, 10],
            },
            {
              text: 'สรุปผล',
              alignment: 'center',
              decoration: 'underline',
              color: '#060e9f',
              margin: [0, 10, 0, 5],
              width: 'auto',
              fontSize: 22,
              bold: true,
            },
            {
              text: this.data_report[0].data[i].result_type,
              alignment: 'left',
              decoration: 'underline',
              color: '##060e9f',
              margin: [0, 0, 0, 5],
              width: 'auto',
              fontSize: 18,
              bold: true,
            },

            {
              text: this.data_report[0].data[i].result_description,
              width: '*',
              fontSize: 14,
              margin: [0, 10],
            },
            {
              text: '_____________________________________________________________________________________________',
              alignment: 'center',
              fontSize: 10,
              color: 'gray',
              margin: [0, 10, 0, 0],
            }
          );
        }
        pdfMake.createPdf(allPage).open();
      }
    );
  }
  filepdf() {
    let formattedDate = new DateTimePipe().transform(
      this.data_report[0].done_measure_date.toString(),
      'FullNoTime'
    );
    let userid = this.data_report[0].user_id;

    let alldata = this.data_report;
    let NewArray = [];
    // for (let i = 0; i < alldata[0].data.length; i++) {
    //   let a = document.getElementById('ScatterChartpdf' + i);
    //   NewArray.push(a);
    // }
    for (let item of this.chartArr) {
      let a = item.toBase64Image();
      NewArray.push(a);
    }

    var img = new Image();
    img.src = NewArray[0];
    pdfMake.fonts = {
      THsarabunNew: {
        normal: 'THSarabun.ttf',
        bold: 'THSarabunNew Bold.ttf',
        italics: 'THSarabunNew Italic.ttf',
        bolditalics: 'THSarabunNew BoldItalic.ttf',
      },
    };
    const allPage = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      header: function (currentPage) {
        return [
          {
            text:
              userid +
              ' | ' +
              formattedDate +
              ' หน้า ' +
              currentPage.toString(),
            width: '*',
            alignment: 'right',
            margin: [40, 20],
          },
        ];
      },
      content: [
        {
          text: this.data_report[0].reportname,
          alignment: 'center',
          fontSize: 24,
          color: '#060e9f',
          margin: [0, 10],
          bold: true,
        },
        {
          text: this.data_report[0].measure_name,
          alignment: 'left',
          fontSize: 22,
          decoration: 'underline',
          margin: [0, 10],
          bold: true,
        },
        {
          text: this.data_report[0].report_description,
          width: '*',
          fontSize: 16,
          margin: [0, 0, 0, 15],
        },
        {
          image: NewArray[0],
          width: 300,
          alignment: 'center',
          margin: [0, 20],
          // pageBreak: '',
        },
        {
          text: this.data_report[0].data[0].xaxis_name,
          alignment: 'left',
          decoration: 'underline',
          color: this.data_report[0].data[0].xaxis_color,
          margin: [0, 0, 0, 5],
          width: 'auto',
          fontSize: 18,
          bold: true,
        },
        {
          text: this.data_report[0].data[0].xaxis_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text:
            'คะแนนต่ำสุด : ' +
            this.data_report[0].data[0].xmin +
            ' คะแนนสูงสุด : ' +
            this.data_report[0].data[0].xmax,
          alignment: 'left',
          fontSize: 18,
          color: '#000000',
          margin: [0, 10, 0, 0],
          bold: true,
        },
        {
          text:
            'ท่านได้ ' +
            parseFloat(this.data_report[0].data[0].xaxis_value).toFixed(2) +
            ' คะแนน',
            // ' อยู่ในช่วงคะแนน ' +
            // this.data_report[0].data[0].xaxis_range +
            // ' คะแนน',
          alignment: 'left',
          fontSize: 18,
          color: this.data_report[0].data[0].xaxis_color,
          margin: [0, 5, 0, 0],
          bold: true,
        },
        {
          text: this.data_report[0].data[0].xaxis_range_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text: '_____________________________________________________________________________________________',
          alignment: 'center',
          fontSize: 10,
          color: 'gray',
          margin: [0, 10],
        },
        {
          text: this.data_report[0].data[0].yaxis_name,
          alignment: 'left',
          decoration: 'underline',
          color: this.data_report[0].data[0].yaxis_color,
          margin: [0, 0, 0, 5],
          width: 'auto',
          fontSize: 18,
          bold: true,
        },

        {
          text: this.data_report[0].data[0].yaxis_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text:
            'คะแนนต่ำสุด : ' +
            this.data_report[0].data[0].ymin +
            ' คะแนนสูงสุด : ' +
            this.data_report[0].data[0].ymax,
          alignment: 'left',
          fontSize: 18,
          color: '#000000',
          margin: [0, 10, 0, 0],
          bold: true,
        },
        {
          text:
            'ท่านได้ ' +
            parseFloat(this.data_report[0].data[0].yaxis_value).toFixed(2) +
            ' คะแนน',
            // ' อยู่ในช่วงคะแนน ' +
            // this.data_report[0].data[0].yaxis_range +
            // ' คะแนน',
          alignment: 'left',
          fontSize: 18,
          color: this.data_report[0].data[0].yaxis_color,
          margin: [0, 5, 0, 0],
          bold: true,
        },
        {
          text: this.data_report[0].data[0].yaxis_range_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text: '_____________________________________________________________________________________________',
          alignment: 'center',
          fontSize: 10,
          color: 'gray',
          margin: [0, 10],
        },
        {
          text: 'สรุปผล',
          alignment: 'center',
          decoration: 'underline',
          color: '#060e9f',
          margin: [0, 10, 0, 5],
          width: 'auto',
          fontSize: 22,
          bold: true,
        },
        {
          text: this.data_report[0].data[0].result_type,
          alignment: 'left',
          decoration: 'underline',
          color: '#060e9f',
          margin: [0, 0, 0, 5],
          width: 'auto',
          fontSize: 18,
          bold: true,
        },

        {
          text: this.data_report[0].data[0].result_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text: '_____________________________________________________________________________________________',
          alignment: 'center',
          fontSize: 10,
          color: 'gray',
          margin: [0, 10],
        },
      ],
      defaultStyle: {
        font: 'THsarabunNew',
      },
    };
    for (let i = 1; i < this.data_report[0].data.length; i++) {
      NewArray[i];
      let img2 = new Image();
      img2.src = NewArray[i];

      allPage.content.push(
        {
          image: NewArray[i],
          width: 300,
          alignment: 'center',
          margin: [0, 40, 0, 20],
        },
        {
          text: this.data_report[0].data[i].xaxis_name,
          alignment: 'left',
          decoration: 'underline',
          color: this.data_report[0].data[i].xaxis_color,
          margin: [0, 0, 0, 5],
          width: 'auto',
          fontSize: 18,
          bold: true,
        },
        {
          text: this.data_report[0].data[i].xaxis_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text:
            'คะแนนต่ำสุด : ' +
            this.data_report[0].data[i].xmin +
            ' คะแนนสูงสุด : ' +
            this.data_report[0].data[i].xmax,
          alignment: 'left',
          fontSize: 18,
          color: '#000000',
          margin: [0, 10, 0, 0],
          bold: true,
        },
        {
          text:
            'ท่านได้ ' +
            parseFloat(this.data_report[0].data[i].xaxis_value).toFixed(2) +
            ' คะแนน',
            // ' อยู่ในช่วงคะแนน ' +
            // this.data_report[0].data[i].xaxis_range +
            // ' คะแนน',
          alignment: 'left',
          fontSize: 18,
          color: this.data_report[0].data[i].xaxis_color,
          margin: [0, 5, 0, 0],
          bold: true,
        },
        {
          text: this.data_report[0].data[i].xaxis_range_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text: '_____________________________________________________________________________________________',
          alignment: 'center',
          fontSize: 10,
          color: 'gray',
          margin: [0, 10],
        },
        {
          text: this.data_report[0].data[i].yaxis_name,
          alignment: 'left',
          decoration: 'underline',
          color: this.data_report[0].data[i].yaxis_color,
          margin: [0, 0, 0, 5],
          width: 'auto',
          fontSize: 18,
          bold: true,
        },

        {
          text: this.data_report[0].data[i].yaxis_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text:
            'คะแนนต่ำสุด : ' +
            this.data_report[0].data[i].ymin +
            ' คะแนนสูงสุด : ' +
            this.data_report[0].data[i].ymax,
          alignment: 'left',
          fontSize: 18,
          color: '#000000',
          margin: [0, 10, 0, 0],
          bold: true,
        },
        {
          text:
            'ท่านได้ ' +
            parseFloat(this.data_report[0].data[i].yaxis_value).toFixed(2) +
            ' คะแนน',
            // ' อยู่ในช่วงคะแนน ' +
            // this.data_report[0].data[i].yaxis_range +
            // ' คะแนน',
          alignment: 'left',
          fontSize: 18,
          color: this.data_report[0].data[i].yaxis_color,
          margin: [0, 5, 0, 0],
          bold: true,
        },
        {
          text: this.data_report[0].data[i].yaxis_range_description,
          width: '*',
          fontSize: 14,
          margin: [0, 0, 0, 10],
        },
        {
          text: '_____________________________________________________________________________________________',
          alignment: 'center',
          fontSize: 10,
          color: 'gray',
          margin: [0, 10],
        },
        {
          text: 'สรุปผล',
          alignment: 'center',
          decoration: 'underline',
          color: '#060e9f',
          margin: [0, 10, 0, 5],
          width: 'auto',
          fontSize: 22,
          bold: true,
        },
        {
          text: this.data_report[0].data[i].result_type,
          alignment: 'left',
          decoration: 'underline',
          color: '##060e9f',
          margin: [0, 0, 0, 5],
          width: 'auto',
          fontSize: 18,
          bold: true,
        },

        {
          text: this.data_report[0].data[i].result_description,
          width: '*',
          fontSize: 14,
          margin: [0, 10],
        },
        {
          text: '_____________________________________________________________________________________________',
          alignment: 'center',
          fontSize: 10,
          color: 'gray',
          margin: [0, 10, 0, 0],
        }
      );
    }
    var pdfDocGenerator = pdfMake.createPdf(allPage);

    pdfDocGenerator.getBase64((base64str) => {

      let data = {
        MEASURE_ID: this.measureid,
        TYPE: this.type,
        base64str: base64str,
        view: this.view_status,
      };
      this.measureService.SaveReportMeasureId(data).subscribe((res) => { });
    });
  }
}
